export const DEFAULT_USER = {
    id: null,
    roles: [],
    isLoggedIn: false,
    fname: '',
    lname: '',
    login: () => { },
    logout: () => { }
}

export * from './provinces'
export * from './next'
export * from './permissions'
export * from './service'
export * from './settings'
